import { render } from "./App.vue?vue&type=template&id=6d1cc4ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6d1cc4ba&lang=css"
script.render = render

export default script